import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOnstarComponent } from './simple-icons-onstar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOnstarComponent ],
    exports:      [ SimpleIconsOnstarComponent ],
    bootstrap:    []
})
export class SimpleIconsOnstarModule {}
